<template>
  <b-modal
    id="ad-iamge-modal"
    ref="adImageModal"
    hide-footer
    hide-header
    body-class="modal-body--no-footer"
    scrollable
    :size="ad.entityAdSubtype === 'Html' ? 'lg' : ''"
  >
    <div class="d-flex justify-content-between border-bottom">
      <div>
        <h6 class="mb-0">
          {{ ad.entityAdSubtype }} - {{ $tk('ClientPortal.Form.AdCreation.AdPreview') }}
        </h6>
        <p class="text-secondary text-sm mb-50">
          {{ ad.name }}
        </p>
      </div>
      <b-button
        size="sm"
        variant="link"
        class="text-secondary align-self-center"
        @click="closeAdImagePreview()"
      >
        <GjIcon
          name="Close"
        />
      </b-button>
    </div>
    <div class="text-center my-1">
      <iframe
        v-if="ad.entityAdSubtype == 'Html'"
        class="ad-preview-iframe"
        :src="ad.mediaUrl"
        scrolling="auto"
        width="100%"
      />
      <video
        v-else-if="ad.entityAdType === 'Video'"
        width="350"
        height="250"
        autoplay
        controls
        muted
      >
        <source
          :src="ad.videoUrl"
          type="video/mp4"
        >
      </video>
      <div
        v-else
        :id="`image-preview-${ad.id}`"
        :key="`Image-${ad.name}`"
        class="ad-image-preview text-center mx-auto"
        :style="{ backgroundImage: 'url(' + ad.mediaUrl + ')' }"
      />
    </div>
    <b-button
      class="float-right"
      variant="outline-dark"
      size="sm"
      @click.prevent="closeAdImagePreview"
    >
      {{ $tk('ClientPortal.Form.Actions.Cancel') }}
    </b-button>
  </b-modal>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    ad: {
      type: Object,
      default: null,
    },
  },
  methods: {
    previewAdImage() {
      this.$refs.adImageModal.show()
    },
    closeAdImagePreview() {
      this.$refs.adImageModal.hide()
    },
  },
}
</script>

<style>
.ad-image-preview {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 300px;
  width: 350px;
}
.ad-preview-iframe {
    min-height: 300px;
}
</style>
